import { slice } from './slice';
export const { load, putAll, added, updated, removed } = slice.actions;
